import classNames from "classnames";
import { useParams } from "react-router";
import { TemplateClassNames } from "../../../../types/template-layouts";
import { CallToAction, CallToActionType, PageModuleType, Sponsor } from "../../../../types/working-model";
import { parseUrl } from "../../../../utils/utils";
import { TypographyItem } from "../../../general-ui/typography-item/typography-item";
import { ParamsProps } from "../../live-event";
import { stylingOverrideReturns } from "../../utils";

interface SponsorCardProps {
	sponsor: Sponsor
	stylingOverrides: stylingOverrideReturns
	template: TemplateClassNames
}

const SponsorCard: React.FC<SponsorCardProps> = ({ sponsor, stylingOverrides, template }) => {
	const { language }: ParamsProps = useParams();

	const {
		moduleTitleOverrides,
		moduleDescriptionOverrides,
		customHeadingOverrides
	} = stylingOverrides;

	return (
		<li className={classNames("sponsor-card")}>
			<div className="sponsor-card-container">
				<div className={classNames("sponsor-card-image")}>
					<img src={sponsor.image} alt="" aria-hidden="true" />
				</div>
				<TypographyItem
					className={classNames('sponsor-card-title stable', moduleTitleOverrides, {
						'evt-heading-3': template === TemplateClassNames.Apollo,
						'evt-heading-4': template !== TemplateClassNames.Apollo,
					})}
					tagName="h3"
				>
					{sponsor.name}
				</TypographyItem>
				<TypographyItem className={classNames('evt-body-text-2 sponsor-card-description', moduleDescriptionOverrides)}>
					{sponsor.description[language] || sponsor.description.base}
				</TypographyItem>
				<SponsorCallToAction
					call_to_action={sponsor.call_to_action}
					// TODO: pass handleScroll from main marketing-page
					handleScroll={() => ({})}
					className={classNames("sponsor-card-call-to-action", customHeadingOverrides)}
					language={language}
					cta_isOn={sponsor.enable_cta}
				/>
			</div>
		</li>
	);
};

export default SponsorCard;

interface Props {
	call_to_action: CallToAction;
	className?: string;
	handleScroll: (moduleType: PageModuleType) => void;
	language: string;
	cta_isOn: boolean;
}

export const SponsorCallToAction: React.FC<Props> = ({ call_to_action, className, handleScroll, language, cta_isOn }: Props) => {
	if (cta_isOn) {
		let link;

		const text = call_to_action.button_name[language] ?? call_to_action.button_name.base;
		switch (call_to_action.type) {
			case CallToActionType.page:
				// TODO: add link to page once built and routes have been determined
				link = <a
					className={className}
					href={call_to_action.content.page}
					target="_blank" rel="noreferrer"
				>
					{text}
				</a>;
				break;
			case CallToActionType.section:
				link = (
					<a className={className} onClick={() => handleScroll(call_to_action.content?.section || 0)}>
						{text}
					</a>
				);
				break;
			case CallToActionType.url:
				link = call_to_action.content.url ?
					<a
						className={className}
						href={parseUrl(call_to_action.content.url)}
						target="_blank" rel="noreferrer"
					>
						{text}
					</a>
					:
					null;
		}
		return <>{link}</>;
	} else return <></>;
};


